import React from 'react'
import { amphtml } from '../../../google-amp/react_amp'
import { StyledInlineTaboolaAMP } from './InlineTaboola.styled'
interface AmpProps {
    width: number
    height: number
    type: string
    layout: string
    'data-publisher': string
    'data-mode': string
    'data-placement': string
    'data-target_type': string
    'data-article': string
    'data-url': string
}

const AmpEmbed = amphtml<AmpProps>('embed')

const InlineTaboolaAmp: React.FC = () => {
    return (
        <StyledInlineTaboolaAMP>
            <AmpEmbed
                width={100}
                height={100}
                type="taboola"
                layout="responsive"
                data-publisher="sevenwestmedia-perthnow"
                data-mode="alternating-thumbnails-reco"
                data-placement="Mid Article Thumbnails AMP"
                data-target_type="mix"
                data-article="auto"
                data-url=""
            >
                <div overflow tabIndex={0} role="button" aria-label="">
                    Read more...
                </div>
            </AmpEmbed>
        </StyledInlineTaboolaAMP>
    )
}

export default InlineTaboolaAmp
